import { Badge } from '@/components/ui/badge';
import { MessageSquare, EyeOff, UserMinus } from 'lucide-react';

const ACTION_LABEL = {
  report:     { text: 'Report only', icon: null, cls: 'bg-gray-100 text-gray-700' },
  disconnect: { text: 'Reporter disconnected', icon: UserMinus, cls: 'bg-amber-100 text-amber-800' },
  block:      { text: 'Reporter blocked them', icon: EyeOff, cls: 'bg-red-100 text-red-800' },
};

/** The private-message evidence a member chose to share with the admins. */
export const DmReportDetail = ({ report }) => {
  const action = ACTION_LABEL[report.action_taken] || ACTION_LABEL.report;
  const Icon = action.icon;
  const messages = report.selected_messages || [];

  return (
    <div className="bg-gray-50 p-3 rounded-lg" data-testid={`dm-report-detail-${report.id}`}>
      <div className="flex items-center gap-2 mb-2 flex-wrap">
        <MessageSquare className="w-4 h-4 text-gray-500" />
        <span className="font-semibold text-sm">Direct message report</span>
        <span className="text-xs text-gray-500">
          about {report.reported_username || 'a member'}
        </span>
        <Badge className={`${action.cls} text-xs`} data-testid={`dm-report-action-taken-${report.id}`}>
          {Icon && <Icon className="w-3 h-3 mr-1 inline" />}{action.text}
        </Badge>
      </div>
      <p className="text-xs text-gray-500 mb-2">
        Only the {messages.length} message{messages.length === 1 ? '' : 's'} the reporter selected are shown.
      </p>
      <div className="space-y-2">
        {messages.map((m) => (
          <div
            key={m.id}
            className={`text-sm rounded-lg px-3 py-2 border ${
              m.from_reported_user ? 'bg-red-50 border-red-200' : 'bg-white border-gray-200'
            }`}
            data-testid={`dm-report-message-${m.id}`}
          >
            <div className="flex items-center gap-2 text-xs text-gray-500 mb-0.5">
              <span className="font-medium text-gray-700">{m.sender_name || 'Member'}</span>
              {m.from_reported_user && <span className="text-red-600">(reported member)</span>}
              {m.created_at && <span>{new Date(m.created_at).toLocaleString()}</span>}
            </div>
            <p className="text-gray-800 whitespace-pre-wrap break-words">{m.content}</p>
          </div>
        ))}
        {messages.length === 0 && (
          <p className="text-sm text-gray-500 italic">No messages were attached to this report.</p>
        )}
      </div>
    </div>
  );
};

export default DmReportDetail;
